// 简体中文
 const cn = {
    header: {
        // 顶部导航栏
        titleList: [
            { title: '主页' },
            { title: '关于我们' },
            { title: 'AIR' },
            // { title: 'GREEN' },
            { title: 'CARE' },
            { title: '2D体验馆' },
            { title: '预约空气检测' },
            { title: '企业咨讯' },
            { title: '加入我们' },
            { title: '订阅我们' }
        ]
    }
}
export default cn


// WEBPACK FOOTER //
// ./src/lang/zh.js